module.exports = require('react/lib/ReactCSSTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-addons-css-transition-group/index.js
// module id = 785
// module chunks = 0